import { createAction, props } from '@ngrx/store';

export interface FormValidity {
  validity: { noticeValid: boolean; evMetaDataValid: boolean };
}

export const change = createAction('CHANGE_VALIDITY', props<FormValidity>());
